<template>
  <v-row class="ma-0 filterBar">
    <v-fab-transition>
      <Tooltip
        :content="(hidden ? 'Open' : 'Close') + ' filter bar'"
        bottom
        :icon="hidden ? 'filter-plus' : 'filter-minus'"
      >
        <v-btn
          @click="hidden = !hidden"
          color="light-blue"
          fab
          :dark="hidden"
          :icon="!hidden"
          small
        >
          <v-icon v-show="hidden">mdi-filter-plus</v-icon>
          <v-icon v-show="!hidden">mdi-filter-minus-outline</v-icon>
        </v-btn>
      </Tooltip>
    </v-fab-transition>
    <v-slide-x-transition>
      <v-col cols="auto" v-show="!hidden">
        <v-row>
          <v-col
            cols="auto"
            class="py-0 mx-1"
            v-if="searchOptions.length && isSearch"
          >
            <Search
              :items="searchOptions"
              v-model="filterObj.search"
              @input="updateFilter"
            />
          </v-col>
          <v-divider v-if="isSearch" vertical> </v-divider>
          <v-col cols="auto" class="py-0 mx-1" v-if="isLimit">
            <Limit v-model="filterObj.limit" @input="updateFilter" />
          </v-col>
          <v-divider v-if="isLimit" vertical> </v-divider>
          <v-col cols="auto" class="py-0 mx-1" v-if="isSort">
            <Sort
              v-model="filterObj.sort"
              :items="sortOptions"
              @input="updateFilter"
            />
          </v-col>
          <v-divider v-if="isSort && isDate" vertical> </v-divider>
          <v-col cols="auto" class="py-1 mx-1" v-if="isDate">
            <DatePicker :options="dateOptions" @changed="updateFilter" />
          </v-col>
        </v-row>
      </v-col>
    </v-slide-x-transition>
    <v-spacer> </v-spacer>
  </v-row>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";
import Search from "./Search.vue";
import Limit from "./Limit.vue";
import Sort from "./Sort.vue";
import DatePicker from "./DatePicker.vue";
import Tooltip from "@/components/Tooltip.vue";

export default Vue.extend({
  components: { Sort, Limit, Search, DatePicker, Tooltip },
  name: "FilterBar",

  data() {
    return {
      hidden: true,
    };
  },
  props: {
    filter: VueTypes.any.def({}),
    sortOptions: VueTypes.any.def([]),
    searchOptions: VueTypes.any.def([]),
    dateOptions: VueTypes.any.def({}),
    elements: VueTypes.any.def(["search", "limit", "sort"]),
    defaultVisible: VueTypes.bool.def(true),
  },
  computed: {
    filterObj(): unknown {
      return this.filter;
    },
    isSearch(): boolean {
      return this.exists("search") && this.searchOptions.length > 0;
    },
    isSort(): boolean {
      return this.exists("sort") && this.sortOptions.length > 0;
    },
    isLimit(): boolean {
      return this.exists("limit");
    },
    isDate(): boolean {
      return this.exists("date");
    },
  },
  methods: {
    updateFilter(obj: { key: string; val: any }) {
      const data: any = {};
      const { key, val } = obj;
      data[key] = val;
      // console.log(this.filter);
      this.$emit("changed", data);
    },
    exists(el: string): boolean {
      return this.elements.indexOf(el) >= 0;
    },
  },
  mounted() {
    // console.log(this.filter);
    this.hidden = !this.defaultVisible;
  },
});
</script>
<style>
.filterBar {
  min-height: 55px;
}
</style>
